import Cookie from 'js-cookie';

export const getTrackingUUID = () =>
  Cookie.get('babbeltrackinguuid');
